import { render, staticRenderFns } from "./assignMobile.vue?vue&type=template&id=b0f397c2&"
import script from "./assignMobile.vue?vue&type=script&lang=ts&"
export * from "./assignMobile.vue?vue&type=script&lang=ts&"
import style0 from "./assignMobile.vue?vue&type=style&index=0&id=b0f397c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports